import React, { FunctionComponent } from 'react';
import { SiteNav } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { SelectableCompanyListWithModal } from './SelectableListWithModal';
import { useNavigate } from '../../services/routing';

type HeaderNavItem = {
  label: string;
  onClick: () => void;
  hidden?: boolean;
};

type Props = {
  visibleItems: HeaderNavItem[];
  className?: string;
};

export const HeaderNav: FunctionComponent<Props> = ({ visibleItems, className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const logout = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate.root();
  };

  return (
    <SiteNav>
      <SiteNav.Area>
        <SiteNav.Item icon label={t('dashboard:header:userMenuLabel')} className={className}>
          <SiteNav.Item.DropdownItem href="" onClick={(e) => e.preventDefault()}>
            [MOCK] username
          </SiteNav.Item.DropdownItem>

          <SiteNav.Item.DropdownItem onClick={logout} href="">
            {t('dashboard:header:logout')}
          </SiteNav.Item.DropdownItem>
        </SiteNav.Item>

        <SelectableCompanyListWithModal headerItemClassName={className} />

        {visibleItems.map((item) => (
          <SiteNav.Item
            key={item.label}
            label={item.label}
            className={className}
            onClick={(e) => {
              e.preventDefault();
              item.onClick();
            }}
            href=""
          />
        ))}
      </SiteNav.Area>
    </SiteNav>
  );
};
